module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (gon.display_options.reviewOptions && gon.display_options.reviewOptions.lightboxReviews && isReviewFeatured){ ;
__p += '\n<div class="review_container">\n	<div class="review_center">\n		';
 if (review.score) { ;
__p += '\n		<div tabindex="0" role="img" aria-label="' +
((__t = ( I18n.t('photo_item.review.star_rating', { reviewScore: review.score }) )) == null ? '' : __t) +
'" class="star_holder star_' +
((__t = ( review.score )) == null ? '' : __t) +
'"></div>\n		';
 } ;
__p += '\n		';
 if (review.title) { ;
__p += '\n		<h2 tabindex="0" class="reviewer_title">' +
((__t = ( review.title )) == null ? '' : __t) +
'</h2>\n		';
 } ;
__p += '\n		';
 if (review.incentivized) { ;
__p += '\n		<p tabindex="0" class="review_incentivized">' +
((__t = ( I18n.t('photo_item.incentivized') )) == null ? '' : __t) +
'</p>\n		';
 } ;
__p += '\n		';
 if (review.content) { ;
__p += '\n		<p tabindex="0" class="review_text">' +
((__t = ( review.content )) == null ? '' : __t) +
'</p>\n		';
 } ;
__p += '\n		';
 if (review.user_name) { ;
__p += '\n		<p tabindex="0" class="reviewer_name">' +
((__t = ( review.user_name )) == null ? '' : __t) +
'</p>\n		';
 } ;
__p += '\n	</div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
}